import React from 'react';

const Icon70OrientationL2ReclinerL = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <rect
      x="296.82"
      y="188.45"
      width="216.75"
      height="216.75"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="296.82"
      y="136.2"
      width="216.75"
      height="52.25"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M80.07,188.45h216.75v216.75H94.57c-8,0-14.5-6.5-14.5-14.5v-202.25h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M38.08,136.2h41.99s216.75,0,216.75,0v52.25H80.07s0,206.49,0,206.49c0,5.66-4.59,10.26-10.26,10.26h-31.73c-5.66,0-10.26-4.59-10.26-10.26v-248.48c0-5.66,4.59-10.26,10.26-10.26Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <g>
      <rect
        x="80.07"
        y="405.2"
        width="216.75"
        height="216.75"
        transform="translate(-325.12 702.02) rotate(-90)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M150.58,508.37h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        transform="translate(-480.55 805.2) rotate(-90)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M-45.42,487.45h198.75c4.97,0,9,4.03,9,9v43.25H-54.42v-43.25c0-4.97,4.03-9,9-9Z"
        transform="translate(-459.62 567.52) rotate(-90)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M223.57,487.45h198.75c4.97,0,9,4.03,9,9v43.25h-216.75v-43.25c0-4.97,4.03-9,9-9Z"
        transform="translate(836.52 190.63) rotate(90)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
    </g>
    <g>
      <rect
        x="513.57"
        y="188.45"
        width="216.75"
        height="216.75"
        transform="translate(1243.89 593.65) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M739.5,136.2h23.49c5.07,0,9.18,4.11,9.18,9.18v259.82h-32.67c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        transform="translate(1502.49 541.4) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M513.57,136.2h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
        transform="translate(1243.89 324.65) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M513.57,405.2h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
    </g>
    <line
      x1="296.82"
      y1="188.45"
      x2="296.82"
      y2="405.2"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon70OrientationL2ReclinerL;
